import React, {useEffect} from "react";
import ReactGA from "react-ga4";
import {useLocation} from "react-router-dom";

type GAProps = {};

const collectGA = window.location.hostname.includes("stage") || window.location.hostname === "si.sas.com";

export const GoogleAnalytics = (props: GAProps) => {
  let location = useLocation();

  useEffect(() => {
    ReactGA.initialize("G-BLG14HYP5E", {testMode: !collectGA, gaOptions: {send_page_view: true}});
  }, []);

  useEffect(() => {
    ReactGA.send("pageview");
  }, [location]);
  return <></>;
};
